
import { Component, Prop, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";

@Component({
  components: {
    FormValidator,
  },
})
export default class TicketTransportForm extends Mixins(FormValidator) {
  @Prop({ required: false })
  private dataPreguntas!: Array<any>;
  @Prop({ required: false })
  private dataRespuestas!: Array<any>;

  patentes: Array<any> = [];
  recorridos: Array<any> = [];
  paraderos: Array<any> = [];
  comunas: Array<any> = [];

  patentesFiltradas: any = [];
  recorridosFiltrados: any = [];
  paraderosFiltrados: any = [];
  comunasFiltradas: Array<any> = [];

  modalidades = [
    { codigo: "Bus" },
    { codigo: "Zona Paga" },
    { codigo: "Metro" },
    { codigo: "Metro Tren" },
  ];

  private localeCalendar = {
    days: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
    daysShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    monthsShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  };

  minDate: any;
  maxDate: any;

  get limitBetween() {
    return (date: string) => {
      this.minDate;
      return date >= this.minDate && date <= this.maxDate;
    };
  }

  mounted() {
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    this.maxDate = today
      .toISOString()
      .split("T")[0]
      .replace(/-/g, "/");
    this.minDate = oneYearAgo
      .toISOString()
      .split("T")[0]
      .replace(/-/g, "/");
    //this.getDataPatentes();
    //this.getDataParaderos();
    this.getDataRecorridos();
    this.getOptions();
    this.getComunas();
    this.setRules();
  }

  async getOptions() {
    this.dataPreguntas.forEach((pregunta: any) => {
      switch (pregunta.transporte_pregunta.nombre) {
        // case "comuna_incidente":
        //   pregunta.loading = true;
        //   this.getComunas(pregunta).then((_) => (pregunta.loading = false));
        //   break;
        // case "placa_patente":
        //   pregunta.loading = true;
        //   pregunta.options = this.patentes;
        //   pregunta.loading = false;
        //   pregunta.filter = this.filterPatente;
        //   break;
        // case "numero_servicio":
        //   pregunta.loading = true;
        //   pregunta.options = this.recorridos;
        //   pregunta.loading = false;
        //   pregunta.filter = this.filterRecorrido;
        //   break;
        // case "codigo_paradero":
        //   pregunta.loading = true;
        //   pregunta.options = this.paraderos;
        //   pregunta.loading = false;
        //   pregunta.filter = this.filterParadero;
        //   break;
        case "modalidad_viaje":
          pregunta.loading = true;
          pregunta.options = this.modalidades;
          pregunta.loading = false;
          break;
      }
    });
  }

  async setRules() {
    this.dataPreguntas.forEach((pregunta: any, index: number) => {
      // Set validation rules based on question type and requirements
      if (pregunta.obligatorio == 1) {
        pregunta.rules = [this.formIsRequired];
      } else {
        pregunta.rules = [this.dummy];
      }

      switch (pregunta.transporte_pregunta.nombre) {
        case "numero_tarjeta": // Number input
          pregunta.rules.push(
            (value: number) => value > 9999999 || "Número de tarjeta inválido"
          );
          break;
        default:
          break;
      }

      // Set specific validation for executive name field
      if (pregunta.transporte_pregunta.nombre === "nombre_ejecutivo") {
        pregunta.keydownHandler = this.filterInput;
      }
    });
  }

  async selectedProxy(pregunta: any) {
    (this.$refs["qProxy" + pregunta.id] as any)[0].hide();
  }

  async getComunas() {
    this.$axios
      .get("comunas/listar")
      .then((response) => {
        this.comunas = response.data.map((comuna: any) => {
          return {
            codigo: comuna.label,
            value: comuna.value,
          };
        });
        this.comunasFiltradas = this.comunas;
        // pregunta.options = this.comunas; // Esto ya no sería necesario
        // pregunta.filter = this.filterDistrict; // Usar el nuevo nombre del filtro
        // this.comunas = response.data;
        // pregunta.options = this.comunas;
        // pregunta.filter = this.filterDistrict;
      })
      .catch((error) => {})
      .finally(() => {});
  }

  async getDataPatentes(filtro: string) {
    const pregunta = this.dataPreguntas.find(
      (pregunta: any) => pregunta.transporte_pregunta.nombre == "placa_patente"
    );
    pregunta.loading = true;

    this.$axios
      .get("data-transporte-patentes", {
        params: {
          filter: {
            where: {
              codigo: { like: "%" + filtro + "%", options: "i" },
            },
            fields: ["id", "codigo"],
          },
        },
      })
      .then((response) => {
        this.patentes = response.data;
        this.patentesFiltradas = this.patentes;
      })
      .catch((error) => {
        this.$q.notify({
          message: this.$t("notification.problem") as string,
          color: "principal",
          position: "top",
          timeout: 5000,
        });
        this.patentes = [];
      })
      .finally(() => {
        pregunta.loading = false;
      });
  }

  async getDataParaderos(filtro: string) {
    const pregunta = this.dataPreguntas.find(
      (pregunta: any) =>
        pregunta.transporte_pregunta.nombre == "codigo_paradero"
    );
    pregunta.loading = true;

    this.$axios
      .get("data-transporte-paraderos", {
        params: {
          filter: {
            where: {
              codigo: { like: "%" + filtro + "%", options: "i" },
            },
            fields: ["id", "codigo"],
          },
        },
      })
      .then((response) => {
        this.paraderos = response.data;
        this.paraderosFiltrados = this.paraderos;
      })
      .catch((error) => {
        this.$q.notify({
          message: this.$t("notification.problem") as string,
          color: "principal",
          position: "top",
          timeout: 5000,
        });
        this.paraderos = [];
      })
      .finally(() => {
        pregunta.loading = false;
      });
  }

  async getDataRecorridos() {
    this.$axios
      .get("data-transporte-recorridos", {
        params: {
          filter: {
            fields: ["id", "codigo"],
          },
        },
      })
      .then((response) => {
        this.recorridos = response.data;
      })
      .catch((error) => {
        this.$q.notify({
          message: this.$t("notification.problem") as string,
          color: "principal",
          position: "top",
          timeout: 5000,
        });
      })
      .finally(() => {});
  }

  filterDistrict(val: string, update: any) {
    const data = this.comunas; // Lista original de comunas

    if (!val) {
      update(() => {
        this.comunasFiltradas = data; // Mostrar todas si el campo está vacío
      });
      return;
    }

    // Lógica de filtrado
    update(() => {
      const needle = val.toLowerCase();
      this.comunasFiltradas = data.filter((comuna: any) => {
        // Asumiendo que el nombre de la comuna está en 'label'
        return comuna.codigo.toLowerCase().includes(needle);
      });
    });
  }

  // filterDistrict(val: string, update: any) {
  //   var pregunta = this.dataPreguntas.find(
  //     (p: any) => p.transporte_pregunta.nombre == "comuna_incidente"
  //   );

  //   var preguntaIndex = this.dataPreguntas.findIndex(
  //     (p: any) => p.id == pregunta.id
  //   );

  //   if (val === "" || val == undefined) {
  //     update(() => {
  //       pregunta.options = this.comunas;
  //     });
  //     return;
  //   }

  //   update(() => {
  //     let value = val.toLowerCase();
  //     pregunta.options = (this.comunas as any).filter((comuna: any) => {
  //       return (
  //         comuna.label.toLowerCase().indexOf(value) > -1 ||
  //         comuna.label === this.dataRespuestas[preguntaIndex]
  //       );
  //     });
  //   });
  // }

  // filterPatente(val: string, update: any) {
  //   var pregunta = this.dataPreguntas.find((p: any) =>
  //     p.transporte_pregunta.nombre == 'placa_patente'
  //   )

  //   var preguntaIndex = this.dataPreguntas.findIndex((p: any) =>
  //     p.id == pregunta.id
  //   )

  //   if (val === "" || val == undefined) {
  //     update(() => {
  //       pregunta.options = this.patentes;
  //     });
  //     return;
  //   }

  //   update(() => {
  //     let value = val.toLowerCase();
  //     pregunta.options = (this.patentes as any).filter((patente: any) => {
  //       return (
  //         patente.toLowerCase().indexOf(value) > -1 ||
  //         patente === this.dataRespuestas[preguntaIndex]
  //       );
  //     });
  //     return;
  //   });
  // }

  // filterParadero(val: string, update: any) {
  //   var pregunta = this.dataPreguntas.find((p: any) =>
  //     p.transporte_pregunta.nombre == 'codigo_paradero'
  //   )

  //   var preguntaIndex = this.dataPreguntas.findIndex((p: any) =>
  //     p.id == pregunta.id
  //   )

  //   if (val === "" || val == undefined) {
  //     update(() => {
  //       pregunta.options = this.paraderos;
  //     });
  //     return;
  //   }

  //   update(() => {
  //     let value = val.toLowerCase();
  //     pregunta.options = (this.paraderos as any).filter((paradero: any) => {
  //       return (
  //         paradero.toLowerCase().indexOf(value) > -1 ||
  //         paradero === this.dataRespuestas[preguntaIndex]
  //       );
  //     });
  //   });
  // }

  // filterRecorrido(val: string, update: any) {
  //   var pregunta = this.dataPreguntas.find((p: any) =>
  //     p.transporte_pregunta.nombre == 'numero_servicio'
  //   )

  //   var preguntaIndex = this.dataPreguntas.findIndex((p: any) =>
  //     p.id == pregunta.id
  //   )

  //   if (val === "" || val == undefined) {
  //     update(() => {
  //       pregunta.options = this.recorridos;
  //     });
  //     return;
  //   }

  //   update(() => {
  //     let value = val.toLowerCase();
  //     pregunta.options = (this.recorridos as any).filter((recorrido: any) => {
  //       return (
  //         recorrido.toLowerCase().indexOf(value) > -1 ||
  //         recorrido === this.dataRespuestas[preguntaIndex]
  //       );
  //     });
  //   });
  // }

  filterRecorridos(val: string, update: any) {
    const data = this.recorridos;

    if (!val) {
      update(() => {
        this.recorridosFiltrados = data;
      });
      return;
    }

    const needle = val.toLowerCase();

    update(() => {
      this.recorridosFiltrados = this.recorridos.filter((p) =>
        p.codigo.toLowerCase().includes(needle)
      );
    });
    return;
  }

  filterParaderos(val: string, update: any) {
    if (!val) {
      update(() => {
        this.paraderosFiltrados = [];
      });
      return;
    }

    if (val.length == 2) {
      update(() => {
        this.getDataParaderos(val);
      });
    } else if (val.length > 2) {
      const needle = val.toLowerCase();

      update(() => {
        this.paraderosFiltrados = this.paraderos.filter((p) =>
          p.codigo.toLowerCase().includes(needle)
        );
      });
    } else {
      update(() => {
        this.paraderosFiltrados = [];
      });
      return;
    }
  }

  filterPatentes(val: any, update: any) {
    if (!val) {
      update(() => {
        this.patentesFiltradas = [];
      });
      return;
    }

    if (val.length == 2) {
      update(() => {
        this.getDataPatentes(val);
      });
    } else if (val.length > 2) {
      const needle = val.toLowerCase();

      update(() => {
        this.patentesFiltradas = this.patentes.filter((p) =>
          p.codigo.toLowerCase().includes(needle)
        );
      });
    } else {
      update(() => {
        this.patentesFiltradas = [];
      });
      return;
    }
  }

  filterInput(event: any) {
    // Permite letras, espacios, teclas de navegación (flechas, Tab, etc.)
    // y la tecla de borrar/eliminar.
    const allowed = /^[a-zA-Z\sñÑáÁéÉíÍóÓúÚüÜ]$/;

    // El 'key' de eventos de teclado es más limitado y no incluye todos los códigos.
    // Usamos el 'keyCode' o 'key' para controlar.

    // Si la tecla es una letra, espacio o una tecla de control (como Backspace, Tab, Enter)
    if (
      allowed.test(event.key) ||
      event.ctrlKey ||
      event.metaKey ||
      event.keyCode === 8 ||
      event.keyCode === 9
    ) {
      return; // Permitir la entrada
    } else {
      // Si es un número o un carácter especial, prevenimos la acción por defecto (escribir el carácter)
      event.preventDefault();
    }
  }

  private obtenerFechaIncidente(): string | null {
    // 1. Buscamos el índice de la pregunta que tiene el nombre técnico 'fecha_incidente'
    const index = this.dataPreguntas.findIndex(
      (p) => p.transporte_pregunta.nombre === "fecha_incidente"
    );

    // 2. Si existe y hay una respuesta en ese índice, la retornamos
    if (index !== -1 && this.dataRespuestas[index]) {
      return this.dataRespuestas[index];
    }

    return null;
  }
  private validarHorasFuturas(hr: number, min: number | null): boolean {
    const fechaIncidenteStr = this.obtenerFechaIncidente();

    // Si aún no eligen fecha, por seguridad restringimos a la hora actual
    if (!fechaIncidenteStr) {
      return this.verificarRestriccionHoy(hr, min);
    }

    // Parsear la fecha del incidente (DD-MM-YYYY)
    const [dia, mes, anio] = fechaIncidenteStr.split("-").map(Number);
    const fechaIncidente = new Date(anio, mes - 1, dia);
    fechaIncidente.setHours(0, 0, 0, 0);

    // Fecha de hoy (sin horas para comparar solo el día)
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // LÓGICA:
    // Si la fecha del incidente es MENOR que hoy (pasado), todas las horas son válidas (true)
    if (fechaIncidente < hoy) {
      return true;
    }

    // Si es HOY, aplicamos la restricción de hora actual
    return this.verificarRestriccionHoy(hr, min);
  }
  // Función auxiliar para no repetir código de validación de "Hoy"
  private verificarRestriccionHoy(hr: number, min: number | null): boolean {
    const ahora = new Date();
    const horaActual = ahora.getHours();
    const minutoActual = ahora.getMinutes();

    if (min === null) {
      return hr <= horaActual;
    }
    if (hr < horaActual) {
      return true;
    }
    if (hr === horaActual) {
      return min <= minutoActual;
    }
    return false;
  }
  //   private validarHorasFuturas(hr: number, min: number | null): boolean {
  //     console.log(this.dataRespuestas)
  //   const ahora = new Date();
  //   const horaActual = ahora.getHours();
  //   const minutoActual = ahora.getMinutes();

  //   // Si min es null, Quasar está validando si la hora (hr) es habilitable
  //   if (min === null) {
  //     return hr <= horaActual;
  //   }

  //   // Si la hora es menor a la actual, todos los minutos son válidos
  //   if (hr < horaActual) {
  //     return true;
  //   }

  //   // Si la hora es la misma que la actual, solo minutos menores o iguales al actual
  //   if (hr === horaActual) {
  //     return min <= minutoActual;
  //   }

  //   return false;
  // }
}
